import React from "react";
import { compose } from "src/helpers";
import {
    withHookForCoupons,
    withHookForAggregateCoupon,
} from "src/modules/coupon/operations";
import { withStateAndActionsForCoupon } from "src/modules/coupon/resolvers";
import ListView from "./component";

const List: React.FC = (props: any) => {
    return <ListView {...props} />;
};

export default compose(
    withStateAndActionsForCoupon,
    withHookForCoupons,
    withHookForAggregateCoupon,
)(List);
